import { render, staticRenderFns } from "./CampaignCoupon.vue?vue&type=template&id=7c168b51&"
import script from "./CampaignCoupon.vue?vue&type=script&lang=js&"
export * from "./CampaignCoupon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports